import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from '../header/Header';
import { Popups } from './popups/Popups';

const Layout = () => {
    const userSuccess = localStorage.getItem('user_success');

    return (
        <div className={`${userSuccess ? 'app' : ''}`}>
            <Header />
            <Outlet />
            <Popups />
        </div>
    );
};

export default Layout;


